import { Contact, SaveContact, ContactType } from 'model/contact';
import { ContactDto, SaveContactDto } from './ContactDtos';

/**
 * Convert ContactDto (snake_case from API) to Contact model (camelCase)
 * @param dto ContactDto from API response
 * @returns Contact model
 */
export const convertToContact = (dto: ContactDto): Contact => {
    return {
        id: dto.id,
        organizationId: dto.organization_id,
        uuid: dto.uuid,
        firstName: dto.first_name,
        lastName: dto.last_name,
        email: dto.email,
        phone: dto.phone,
        contactType: dto.contact_type as ContactType,
        createdAt: dto.created_at,
        updatedAt: dto.updated_at
    };
};

/**
 * Convert SaveContact model (camelCase) to SaveContactDto (snake_case for API)
 * Wraps the payload in the required organization_contact structure
 * @param contact SaveContact model
 * @returns SaveContactDto for API request
 */
export const convertToSaveContactDto = (contact: SaveContact): SaveContactDto => {
    return {
        organization_contact: {
            organization_id: contact.organizationId,
            first_name: contact.firstName,
            last_name: contact.lastName,
            email: contact.email,
            phone: contact.phone,
            contact_type: contact.contactType
        }
    };
};
